/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MobilePhoneIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MobilePhoneIcon({
  children,
  viewPath = "/DesignSystem/Svgs/MobilePhoneIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="MobilePhoneIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-ZMMo2F': alignSelf,'--mt-2-ZMMo2F': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZMMo2F': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZMMo2F': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZMMo2F': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZMMo2F': opacity,'--w-10-ZMMo2F': typeof width === 'number' ? `${width}px` : width,'--h-11-ZMMo2F': typeof height === 'number' ? `${height}px` : height,'--a-7-ZMMo2F': isAnimated ? animation : "none",'--sd-8-ZMMo2F': isAnimated ? strokeDashoffset : 0,'--sd-9-ZMMo2F': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="MobilePhoneIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M21.5 29.7h-11c-1.8 0-3.3-1.5-3.3-3.3V5.6c0-1.8 1.5-3.3 3.3-3.3h11.1c1.8 0 3.3 1.5 3.3 3.3v20.8c0 1.8-1.5 3.3-3.4 3.3z"
 style={{'--f-12-ZMMo2F': fill,'--s-13-ZMMo2F': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="MobilePhoneIcon.SvgPath:1"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M21.7 3.4c0 1.8-1.5 3.3-3.3 3.3h-4.6c-1.8 0-3.3-1.5-3.3-3.3"
 style={{'--f-12-ZMMo2F': fill,'--s-13-ZMMo2F': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}